import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function WhyChooseUs() {
  const testimonials = [
    {
      name: 'Ahmed Al Mansouri',
      company: 'Tech Innovations LLC',
      image: 'https://public.readdy.ai/ai/img_res/589aaef16f03adf65e53d517f93e1e26.jpg',
      text: 'Afriq Global transformed our digital presence completely. Their team at Almadaa Digital delivered exceptional results that exceeded our expectations. Highly recommended!'
    },
    {
      name: 'Sarah Johnson',
      company: 'Global Ventures',
      image: 'https://readdy.ai/api/search-image?query=professional%20businesswoman%20in%20corporate%20attire%20confident%20expression%20modern%20office%20setting%20executive%20portrait%20clean%20simple%20background%20professional%20headshot%20photography%20style&width=200&height=200&seq=client2&orientation=squarish',
      text: 'The travel services provided by Afriq Travel made our corporate trips seamless. From bookings to logistics, everything was handled professionally and efficiently.'
    },
    {
      name: 'Mohammed Hassan',
      company: 'Retail Solutions Group',
      image: 'https://readdy.ai/api/search-image?query=professional%20Middle%20Eastern%20business%20executive%20in%20suit%20friendly%20smile%20contemporary%20office%20background%20Dubai%20businessman%20portrait%20clean%20simple%20background%20professional%20photography&width=200&height=200&seq=client3&orientation=squarish',
      text: 'Working with Afriq Global has been a game-changer for our business. Their personalized approach and expertise in both digital marketing and travel services are unmatched.'
    },
    {
      name: 'Emily Chen',
      company: 'Fashion Forward',
      image: 'https://readdy.ai/api/search-image?query=professional%20Asian%20businesswoman%20in%20elegant%20business%20attire%20confident%20pose%20modern%20corporate%20setting%20executive%20portrait%20clean%20simple%20background%20professional%20headshot%20style&width=200&height=200&seq=client4&orientation=squarish',
      text: 'The creative content and social media management from Almadaa Digital helped us reach new audiences and grow our brand significantly. Truly exceptional service!'
    },
    {
      name: 'Khalid Al Zaabi',
      company: 'Construction Dynamics',
      image: 'https://readdy.ai/api/search-image?query=professional%20Middle%20Eastern%20businessman%20in%20formal%20business%20suit%20confident%20expression%20modern%20office%20background%20Dubai%20executive%20portrait%20clean%20simple%20background%20professional%20photography%20style&width=200&height=200&seq=client5&orientation=squarish',
      text: 'Afriq Global understands the Dubai market perfectly. Their knowledge of Mainland regulations and business practices made our collaboration smooth and successful.'
    },
    {
      name: 'Lisa Martinez',
      company: 'Hospitality Group',
      image: 'https://readdy.ai/api/search-image?query=professional%20businesswoman%20in%20corporate%20dress%20warm%20smile%20contemporary%20office%20environment%20executive%20portrait%20clean%20simple%20background%20professional%20headshot%20photography&width=200&height=200&seq=client6&orientation=squarish',
      text: 'From web development to travel arrangements, Afriq Global is our one-stop solution. Their team is responsive, professional, and delivers outstanding results every time.'
    }
  ];

  const clientLogos = [
    'Tech Innovations',
    'Global Ventures',
    'Retail Solutions',
    'Fashion Forward',
    'Construction Dynamics',
    'Hospitality Group',
    'Digital Enterprises',
    'Smart Solutions'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Why Choose Afriq Global</h1>
            <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
              Your trusted partner for digital excellence and seamless travel experiences
            </p>
          </div>
        </div>
      </section>

      {/* Key Strengths */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Strengths</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              What sets Afriq Global apart from the competition
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Personalized Approach */}
            <div className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-blue-700 cursor-pointer">
              <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-user-star-fill text-4xl text-blue-700"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Personalized Approach</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                We don't believe in one-size-fits-all solutions. Every client is unique, and we take the time to understand your specific needs, challenges, and goals.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our tailored strategies are designed specifically for your business, ensuring that every solution we deliver aligns perfectly with your objectives and delivers maximum value.
              </p>
            </div>

            {/* Expert Team */}
            <div className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-blue-700 cursor-pointer">
              <div className="w-20 h-20 flex items-center justify-center bg-yellow-100 rounded-full mb-6">
                <i className="ri-team-fill text-4xl text-yellow-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Skilled Professional Team</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Our team consists of experienced professionals with expertise in digital marketing, creative services, web development, and travel logistics.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With years of industry experience and a passion for excellence, our team brings the knowledge and skills needed to deliver exceptional results that drive your success.
              </p>
            </div>

            {/* One-Stop Shop */}
            <div className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-blue-700 cursor-pointer">
              <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-store-3-fill text-4xl text-blue-700"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">One-Stop Shop Solution</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Why work with multiple vendors when you can have everything under one roof? Afriq Global offers comprehensive digital and travel services in one place.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                From social media management to flight bookings, from web development to logistics services, we provide integrated solutions that save you time, money, and hassle.
              </p>
            </div>

            {/* Dubai Market Expertise */}
            <div className="bg-white p-10 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-blue-700 cursor-pointer">
              <div className="w-20 h-20 flex items-center justify-center bg-yellow-100 rounded-full mb-6">
                <i className="ri-building-fill text-4xl text-yellow-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Dubai Mainland Expertise</h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                As a Dubai Mainland registered company, we have deep knowledge of local regulations, market dynamics, and business practices in the UAE.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our understanding of the Dubai market and strong local connections enable us to navigate complexities efficiently and deliver solutions that work in this unique business environment.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Success Stories</h2>
            <p className="text-xl text-gray-600">Real results from real clients</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-blue-700 to-blue-900 p-8 rounded-2xl text-white text-center">
              <div className="text-5xl font-bold mb-2">150+</div>
              <p className="text-xl">Satisfied Clients</p>
            </div>
            <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 p-8 rounded-2xl text-black text-center">
              <div className="text-5xl font-bold mb-2">500+</div>
              <p className="text-xl">Projects Completed</p>
            </div>
            <div className="bg-gradient-to-br from-blue-700 to-blue-900 p-8 rounded-2xl text-white text-center">
              <div className="text-5xl font-bold mb-2">98%</div>
              <p className="text-xl">Client Satisfaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
            <p className="text-xl text-gray-600">Don't just take our word for it</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover object-top mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-sm text-gray-600">{testimonial.company}</p>
                  </div>
                </div>
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 w-5 h-5 flex items-center justify-center"></i>
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed italic">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Logos */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Trusted by Leading Brands</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {clientLogos.map((logo, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-md flex items-center justify-center hover:shadow-lg transition-all duration-300"
              >
                <span className="text-xl font-bold text-gray-700">{logo}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Ready to Experience the Afriq Global Difference?</h2>
          <p className="text-xl text-gray-200 mb-10">
            Join hundreds of satisfied clients who trust us with their digital and travel needs
          </p>
          <Link 
            to="/contact" 
            className="inline-block px-10 py-4 bg-yellow-500 hover:bg-yellow-600 text-black font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get Started Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
